
import ImageUploader from "./ImageUploader";
import "./imageDashboard.scss";

const ImageUploaderModal = ({ open, onClose, uploadEndpoint, onUploaded }) => {
    if (!open) return null;
    const stop = (e) => e.stopPropagation();
    return (
        <div className="uploaderModalOverlay" onClick={onClose}>
            <div className="uploaderModalBox" onClick={stop}>
                <div className="uploaderModalHeader">
                    <h2>Upload Images</h2>
                    <button className="closeBtn" onClick={onClose}>✕</button>
                </div>
                <div className="uploaderModalBody">
                    <ImageUploader uploadEndpoint={uploadEndpoint} onUploadComplete={onUploaded} />
                </div>
            </div>
        </div>
    );
};

export default ImageUploaderModal;
